<template>
  <main id="aa">
    <div id="top-controls">
      <div id="rounds">
        <div class="rounds-selector-wrapper">
          <select class="rounds-selector form-control" id="rounds-1">
            <option value="select">Select round...</option>
          </select>
        </div>
        <span class="bold comparison">&#x2194;</span>
        <div class="rounds-selector-wrapper">
          <select class="rounds-selector form-control" id="rounds-2">
            <option value="select">Compare...</option>
          </select>
        </div>
      </div>
      <div id="club-buttons"></div>
    </div>
    <div id="layout-wrapper">
      <div id="chart"></div>
      <div id="green-wrapper">
        <div id="green"></div>
        <div class="carry-total-buttons">
          <button id="carry-btn">Carry</button>
          <button class="active" id="total-btn">Total</button>
        </div>
      </div>
      <div class="horiz-scroll" id="table-wrapper">
        <table id="stats">
          <thead class="tight-lines">
            <tr>
              <th class="bold col-left" id="shot-count"></th>
              <th class="stat-btn" data-stat="ballspeed" id="ballspeed-btn">Ball<br />Speed</th>
              <th class="stat-btn" data-stat="clubspeed" id="clubspeed-btn">Club<br />Speed</th>
              <th class="stat-btn" data-stat="smash" id="smash-btn">Smash<br />Factor</th>
              <th class="stat-btn highlight" data-stat="distance" id="distance-btn">
                Carry<br />Dist
              </th>
              <th class="stat-btn" data-stat="rolldistance" id="rolldistance-btn">
                Roll<br />Dist
              </th>
              <th class="stat-btn highlight" data-stat="totaldistance" id="totaldistance-btn">
                Total<br />Dist
              </th>
              <th class="stat-btn" data-stat="hla" id="hla-btn">Horiz<br />LA</th>
              <th class="stat-btn" data-stat="vla" id="vla-btn">Vert<br />LA</th>
              <th class="stat-btn" data-stat="totalspin" id="totalspin-btn">Total<br />Spin</th>
              <th class="stat-btn" data-stat="spinaxis" id="spinaxis-btn">Spin<br />Axis</th>
              <th class="stat-btn" data-stat="backspin" id="backspin-btn">Back<br />Spin</th>
              <th class="stat-btn" data-stat="sidespin" id="sidespin-btn">Side<br />Spin</th>
              <th class="stat-btn" data-stat="height" id="height-btn">Apex<br />Height</th>
              <th class="stat-btn" data-stat="flighttime" id="flighttime-btn">Flight<br />Time</th>
              <th class="stat-btn" data-stat="topin" id="topin-btn">Dist<br />to Pin</th>
              <th class="stat-btn" data-stat="faceangle" id="faceangle-btn">Face<br />Angle</th>
              <th class="stat-btn" data-stat="swingpath" id="swingpath-btn">Swing<br />Path</th>
            </tr>
          </thead>
          <tbody>
            <tr class="detail">
              <th class="col-left" id="detail-header">-</th>
              <td id="detail-ballspeed">-</td>
              <td id="detail-clubspeed">-</td>
              <td id="detail-smash">-</td>
              <td class="highlight" id="detail-distance">-</td>
              <td id="detail-rolldistance">-</td>
              <td class="highlight" id="detail-totaldistance">-</td>
              <td id="detail-hla">-</td>
              <td id="detail-vla">-</td>
              <td id="detail-totalspin">-</td>
              <td id="detail-spinaxis">-</td>
              <td id="detail-backspin">-</td>
              <td id="detail-sidespin">-</td>
              <td id="detail-height">-</td>
              <td id="detail-flighttime">-</td>
              <td id="detail-topin">-</td>
              <td id="detail-faceangle"></td>
              <td id="detail-swingpath">-</td>
            </tr>
            <tr class="averages">
              <th class="bold col-left">Avg</th>
              <td id="avg-ballspeed"></td>
              <td id="avg-clubspeed"></td>
              <td id="avg-smash"></td>
              <td class="highlight" id="avg-distance"></td>
              <td id="avg-rolldistance"></td>
              <td class="highlight" id="avg-totaldistance"></td>
              <td id="avg-hla"></td>
              <td id="avg-vla"></td>
              <td id="avg-totalspin"></td>
              <td id="avg-spinaxis"></td>
              <td id="avg-backspin"></td>
              <td id="avg-sidespin"></td>
              <td id="avg-height"></td>
              <td id="avg-flighttime"></td>
              <td id="avg-topin"></td>
              <td id="avg-faceangle"></td>
              <td id="avg-swingpath"></td>
            </tr>
            <tr>
              <th class="col-left">Min</th>
              <td id="min-ballspeed"></td>
              <td id="min-clubspeed"></td>
              <td id="min-smash"></td>
              <td class="highlight" id="min-distance"></td>
              <td id="min-rolldistance"></td>
              <td class="highlight" id="min-totaldistance"></td>
              <td id="min-hla"></td>
              <td id="min-vla"></td>
              <td id="min-totalspin"></td>
              <td id="min-spinaxis"></td>
              <td id="min-backspin"></td>
              <td id="min-sidespin"></td>
              <td id="min-height"></td>
              <td id="min-flighttime"></td>
              <td id="min-topin"></td>
              <td id="min-faceangle"></td>
              <td id="min-swingpath"></td>
            </tr>
            <tr>
              <th class="col-left">Max</th>
              <td id="max-ballspeed"></td>
              <td id="max-clubspeed"></td>
              <td id="max-smash"></td>
              <td class="highlight" id="max-distance"></td>
              <td id="max-rolldistance"></td>
              <td class="highlight" id="max-totaldistance"></td>
              <td id="max-hla"></td>
              <td id="max-vla"></td>
              <td id="max-totalspin"></td>
              <td id="max-spinaxis"></td>
              <td id="max-backspin"></td>
              <td id="max-sidespin"></td>
              <td id="max-height"></td>
              <td id="max-flighttime"></td>
              <td id="max-topin"></td>
              <td id="max-faceangle"></td>
              <td id="max-swingpath"></td>
            </tr>
            <tr>
              <th class="col-left">Dispersion</th>
              <td id="stddev-ballspeed"></td>
              <td id="stddev-clubspeed"></td>
              <td id="stddev-smash"></td>
              <td class="highlight" id="stddev-distance"></td>
              <td id="stddev-rolldistance"></td>
              <td class="highlight" id="stddev-totaldistance"></td>
              <td id="stddev-hla"></td>
              <td id="stddev-vla"></td>
              <td id="stddev-totalspin"></td>
              <td id="stddev-spinaxis"></td>
              <td id="stddev-backspin"></td>
              <td id="stddev-sidespin"></td>
              <td id="stddev-height"></td>
              <td id="stddev-flighttime"></td>
              <td id="stddev-topin"></td>
              <td id="stddev-faceangle"></td>
              <td id="stddev-swingpath"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="creator">
      Advanced Analytics for E6 by
      <a
        href="https://gunghogolf.com"
        target="_blank"
        title="Visit GungHoGolf.com - Golf Simulator Solutions"
      >
        GungHoGolf
      </a>
    </div>
    <div class="hide" id="spin-fix-form">
      Reverse Spin Bug Fix (for Uneekor LM)
      <input id="spin-fix" type="checkbox" />
      <label class="toggle" for="spin-fix">Toggle</label>
    </div>
    <div class="hide">
      <div class="bold">Debugging Info</div>
      <br />
      Rounds JSON
      <br />
      <input class="form-control" id="rounds-json" type="text" />
      <br />
      Shots JSON
      <br />
      <input class="form-control" id="shots-json" type="text" />
    </div>
  </main>
</template>

<script>
import loadInit from '../lib/js-trugolf';

export default {
  name: 'AdvancedAnalytics',

  props: {
    roundID: {
      type: String,
      required: false,
      default: null,
    },
    userID: {
      type: String,
      required: false,
      default: null,
    },
  },

  mounted() {
    loadInit(this.roundID ? this.roundID : null, this.userID ? this.userID : null);
  },
};
</script>

<style scoped>
/* @import '../assets/css/aa.css'; */
</style>
